var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDotsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 6,
    viewBox: "0 0 38 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2123 5.58678C20.7551 5.58678 22.0057 4.33614 22.0057 2.79339C22.0057 1.25064 20.7551 0 19.2123 0C17.6696 0 16.4189 1.25064 16.4189 2.79339C16.4189 4.33614 17.6696 5.58678 19.2123 5.58678Z",
    fill: "#14C6BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 5C28.8807 5 30 3.88071 30 2.5C30 1.11929 28.8807 0 27.5 0C26.1193 0 25 1.11929 25 2.5C25 3.88071 26.1193 5 27.5 5Z",
    fill: "#14C6BB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8497 4.10377C36.7068 4.10377 37.4016 3.40897 37.4016 2.55188C37.4016 1.6948 36.7068 1 35.8497 1C34.9927 1 34.2979 1.6948 34.2979 2.55188C34.2979 3.40897 34.9927 4.10377 35.8497 4.10377Z",
    fill: "#14C6BB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5C11.8807 5 13 3.88071 13 2.5C13 1.11929 11.8807 0 10.5 0C9.11929 0 8 1.11929 8 2.5C8 3.88071 9.11929 5 10.5 5Z",
    fill: "#14C6BB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.55188 4.10377C2.40897 4.10377 3.10377 3.40897 3.10377 2.55188C3.10377 1.6948 2.40897 1 1.55188 1C0.694802 1 0 1.6948 0 2.55188C0 3.40897 0.694802 4.10377 1.55188 4.10377Z",
    fill: "#14C6BB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsIcon);
export default __webpack_public_path__ + "static/media/dots-icon.32d2214ed8b38cd8b5d81afbe1c7c4d8.svg";
export { ForwardRef as ReactComponent };